import React from "react";
import { createRazorpayOrder, verifyRazorpayOrder, checkRazorpayOrderStatus } from "../../services/classApiServices.js";

const PayNow = ({ amount, callback, gymid, user, from, title, processing }) => {
    console.log(user, 'user');

    const handlePayment = async () => {
        try {
            const resdata = await createRazorpayOrder({
                amount,
                currency: "INR",
                gymid,
                customer: {
                    name: user?.name || '',
                    email: user?.email || '',
                    contact: user?.phone || ''
                }
            });
            console.log(resdata, 'data');
            if (!resdata || resdata === "false") {
                return;
            }
            const orderinfo = await resdata.json();
            console.log(orderinfo);

            const data = orderinfo;
            if (!data.success) {
                alert("Error creating order");
                return;
            }

            const { id: order_id, amount: order_amount, currency } = data.order;

            processing({ razorpay_order_id: order_id });

            const options = {
                key: data.key,
                amount: order_amount,
                currency,
                name: from,
                description: `Payment for ${from}`,
                order_id,
                prefill: {
                    name: user?.name || '',
                    email: user?.email || '',
                    contact: user?.phone || ''
                },
                handler: async function (response) {
                    // Fires for card / netbanking / wallet payments.
                    // UPI deep-link payments close the modal and fire ondismiss instead.
                    const verifyinfo = await verifyRazorpayOrder({
                        razorpay_order_id: response.razorpay_order_id,
                        razorpay_payment_id: response.razorpay_payment_id,
                        razorpay_signature: response.razorpay_signature,
                        gymid: gymid
                    });
                    if (!verifyinfo || verifyinfo === "false") return;
                    const verifyRes = await verifyinfo.json();
                    console.log(verifyRes, "verifyRes");

                    if (verifyRes.success) {
                        if (callback) {
                            const res = verifyRes.razorpay_order || null;
                            callback(res);
                        }
                    } else {
                        alert("Payment Verification Failed");
                    }
                },
                modal: {
                    // Fires when the Razorpay modal closes — including after a UPI deep-link
                    // redirect where the handler is never called. We poll the order status
                    // so live UPI payments (GPay / PhonePe) also reach the success screen.
                    ondismiss: async function () {
                        try {
                            const statusRes = await checkRazorpayOrderStatus({ order_id, gymid });
                            if (!statusRes || statusRes === "false") return;
                            const statusData = await statusRes.json();
                            console.log("ondismiss order status:", statusData);

                            if (statusData.success && statusData.order_status === "paid") {
                                if (callback) {
                                    callback({
                                        razorpay_order_id: statusData.razorpay_order_id,
                                        razorpay_payment_id: statusData.razorpay_payment_id,
                                        razorpay_signature: statusData.razorpay_signature,
                                    });
                                }
                            }
                            // If not paid the user simply closed the modal — do nothing.
                        } catch (err) {
                            console.error("ondismiss status check error:", err);
                        }
                    }
                },
                theme: {
                    color: "#3399cc",
                },
            };

            const razorpay = new window.Razorpay(options);
            razorpay.on("payment.failed", function (response) {
                console.error("Razorpay payment.failed:", response.error);
                alert(`Payment failed: ${response.error?.description || "Please try again."}`);
            });
            razorpay.open();
        } catch (error) {
            console.error(error);
            alert("Payment failed!");
        }
    };

    return (
        <button onClick={handlePayment} className="btn btn-primary">
            {title}
        </button>
    );
};

export default PayNow;
